import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from "./components/Home";
import { Dashboard } from "./components/Dashboard";
import Factors from "./components/Factors";
import Annual from "./components/Annual";
import Documents from "./components/Documents";
import Login from "./components/Login";
import Register from "./components/Register";
import Remember from "./components/Remember";
import Profile from "./components/Profile";
import Organization from "./components/Organization";
import OrganizationSetting from "./components/OrganizationSetting";
import Organizations from "./components/Organizations";
import InquiryEconomicCode from "./components/InquiryEconomicCode";
import InquiryStuff from "./components/InquiryStuff";
import MyPlans from "./components/MyPlans";
import PaymentFailed from "./components/PaymentFailed";
import MyTransactions from "./components/MyTransactions";
import Warehouses from "./components/Warehouses";
import Warehouse from "./components/Warehouse";
import Remittances from "./components/Remittances";
import Remittance from "./components/Remittance";
import Receipts from "./components/Receipts";
import Users from "./components/Users";

import Plans from "./components/Managments/Plans";
import Plan from "./components/Managments/Plan";
import User from "./components/Managments/User";
import Transactions from "./components/Managments/Transactions";
import Setting from "./components/Managments/Setting";

import BaseStuffs from "./components/Managments/BaseStuffs";
import Start from "./components/Start";
import Close from "./components/Close";
import CSR from "./components/CSR";

import Reports from "./components/Reports";
import BalanceReport from "./components/BalanceReport";
import IncomeReport from "./components/IncomeReport";
import CapitalReport from "./components/CapitalReport";
import JournalReport from "./components/JournalReport";
import LedgerReport from "./components/LedgerReport";
import TrialbalanceReport from "./components/TrialbalanceReport";
import ExploreReport from "./components/ExploreReport";
import TransctionsReport from "./components/TransctionsReport";
import DebcredReport from "./components/DebcredReport";
import BankTransactionReport from "./components/BankTransactionReport";
import CashTransactionReport from "./components/CashTransactionReport";
import UserlogReport from "./components/UserlogReport";
import CashCloseReport from "./components/CashCloseReport";
import InventoryByWarehouseReport from "./components/InventoryByWarehouseReport";
import WarehouseIOReport from "./components/WarehouseIOReport";

import ExploreWarehouseReport from "./components/ExploreWarehouseReport";
import Cheques from './components/Cheques';

export default class App extends Component {
getDefaultGuid() {
    return '00000000-0000-0000-0000-000000000000';
}
  render() {
    return (
      <Layout>
            <Routes>
                {/*<Route exact path='/' element={<Home />} />*/}
                <Route exact path='/dashboard' element={<Home />} />
                <Route path='/dashboard' element={<Dashboard />} />
                <Route path='/login' element={<Login />} />
                <Route path='/register' element={<Register />} />
                <Route path='/remember' element={<Remember />} />
                <Route path='/profile' element={<Profile />} />

                <Route path='/myplans' element={<MyPlans />} />
                <Route path='/start' element={<Start />} />
                <Route path='/close' element={<Close />} />

                <Route path='/csr' element={<CSR />} />
                <Route path='/reports' element={<Reports />} />
                <Route path='/report/balance' element={<BalanceReport />} />
                <Route path='/report/income' element={<IncomeReport />} />
                <Route path='/report/capital' element={<CapitalReport />} />
                <Route path='/report/journal' element={<JournalReport />} />
                <Route path='/report/ledger' element={<LedgerReport />} />
                <Route path='/report/trialbalance' element={<TrialbalanceReport />} />

                <Route path='/report/explore' element={<ExploreReport Id={this.getDefaultGuid()} IsReverse={false} />} />
                <Route path='/report/explore1/:id' element={<ExploreReport Id={1} IsReverse={false} />} />
                <Route path='/report/explore2/:id' element={<ExploreReport Id={1} IsReverse={false} />} />
                <Route path='/report/explore3/:id' element={<ExploreReport Id={1} IsReverse={false} />} />
                <Route path='/report/explore1u/:id' element={<ExploreReport Id={1} IsReverse={true} />} />
                <Route path='/report/explore2u/:id' element={<ExploreReport Id={1} IsReverse={true} />} />
                <Route path='/report/explore3u/:id' element={<ExploreReport Id={1} IsReverse={true} />} />

                <Route path='/report/transactions/:id' element={<TransctionsReport Id={1} />} />           
                <Route path='/report/debcred' element={<DebcredReport />} />
                <Route path='/report/banktransaction' element={<BankTransactionReport />} />
                <Route path='/report/cashtransaction' element={<CashTransactionReport />} />
                <Route path='/report/userlog' element={<UserlogReport />} />
                <Route path='/report/warehouseio' element={<WarehouseIOReport />} />
                <Route path='/report/inventory' element={<InventoryByWarehouseReport />} />
                
                <Route path='/report/explore/warehouse' element={<ExploreWarehouseReport />} />

                <Route path='/remittance/new1' element={<Remittance IO={1} Id={this.getDefaultGuid()} />} />
                <Route path='/remittance/new2' element={<Remittance IO={2} Id={this.getDefaultGuid()} />} />
                <Route path='/remittance/edit/:id' element={<Remittance Id={1} />} />
                <Route path='/remittances/out' element={<Remittances IO={2} />} />
                <Route path='/remittances/in' element={<Remittances IO={1} />} />

                <Route path='/documents' element={<Documents />} />

                <Route path='/annual' element={<Annual />} />
                
                <Route path='/receipts' element={<Receipts Type={0} />} />
                <Route path='/receipts/in' element={<Receipts Type={1} />} />
                <Route path='/receipts/out' element={<Receipts Type={2} />} />

                <Route path='/cheques/in' element={<Cheques Type={1} />} />
                <Route path='/cheques/out' element={<Cheques Type={2} />} />

                <Route path='/factors/buy' element={<Factors Type={1} />} />
                <Route path='/factors/sale' element={<Factors Type={2} />} />
                <Route path='/factors/buyreturn' element={<Factors Type={3} />} />
                <Route path='/factors/salereturn' element={<Factors Type={4} />} />
                <Route path='/factors/waste' element={<Factors Type={5} />} />

                <Route path='/warehouse/new' element={<Warehouse Id={this.getDefaultGuid()} />} />
                <Route path='/warehouse/edit/:id' element={<Warehouse Id={1} />} />
                <Route path='/warehouses' element={<Warehouses />} />

                <Route path='/business/setting' element={<OrganizationSetting />} />
                <Route path='/business/new' element={<Organization Id={this.getDefaultGuid()} />} />
                <Route path='/business/edit/:id' element={<Organization Id={1} />} />
                <Route path='/business' element={<Organizations />} />
                                
                <Route path='/inquiry/economiccode/' element={<InquiryEconomicCode />} />
                <Route path='/inquiry/stuff/' element={<InquiryStuff />} />

                <Route path='/mytransactions' element={<MyTransactions />} />

                <Route path='/paymentfailed/' element={<PaymentFailed />} />

                <Route path='/users' element={<Users />} />

                <Route path='/plan/new' element={<Plan Id={this.getDefaultGuid()} />} />
                <Route path='/plan/edit/:id' element={<Plan Id={1} />} />
                <Route path='/plans' element={<Plans />} />

                <Route path='/settings' element={<Setting Id={1} />} />

                <Route path='/transactions' element={<Transactions />} />
                <Route path='/basestuffs' element={<BaseStuffs />} />
        </Routes>
      </Layout>
    );
  }
}